import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/motion";
import { Seo } from "../components/Seo";
import { CASE_STUDIES, CASE_STUDIES_INTRO } from "../data/content";

const CaseStudies = () => {
  return (
    <div data-testid="case-studies-page">
      <Seo path="/case-studies" description="Executive-ready UX case studies by Yuva Kumar — TPG Telecom design system, PepsiCo kiosk (shift-left UX), SBI YONO Business governance, Mahindra digital touchpoints & CXO dashboard, and the UX Audit framework." keywords="UX case studies, design system case study, TPG Telecom, PepsiCo kiosk, SBI YONO Business, Mahindra UX, design governance" />
      <section className="pt-40 pb-16">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
          <Reveal><p className="eyebrow mb-6">Case Studies</p></Reveal>
          <Reveal delay={0.1}>
            <h1 className="display text-5xl sm:text-8xl max-w-[16ch]" style={{ color: "var(--text)" }}>Executive-ready deep dives.</h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-3xl text-lg leading-relaxed" style={{ color: "var(--muted-t)" }}>
              {CASE_STUDIES_INTRO}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-32">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10 space-y-6">
          {CASE_STUDIES.map((cs, i) => (
            <Reveal key={cs.slug} delay={i * 0.06}>
              <Link
                to={`/case-studies/${cs.slug}`}
                data-testid={`case-card-${cs.slug}`}
                className="group grid lg:grid-cols-[1.1fr_1fr] gap-8 lg:gap-16 items-center p-6 sm:p-8 surface-card"
              >
                <div className="overflow-hidden order-2 lg:order-1" style={{ borderRadius: "2px" }}>
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={cs.image} alt={cs.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" style={{ filter: "grayscale(0.25) contrast(1.05)" }} />
                  </div>
                </div>
                <div className="order-1 lg:order-2">
                  <div className="flex items-center gap-4 mb-5">
                    <span className="eyebrow">{cs.tag}</span>
                    <span className="text-xs" style={{ color: "var(--muted-t)" }}>{cs.year}</span>
                  </div>
                  <h2 className="display text-3xl sm:text-5xl group-hover:opacity-70 transition-opacity" style={{ color: "var(--text)" }}>{cs.title}</h2>
                  <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--muted-t)" }}>{cs.summary}</p>
                  <span className="mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-widest" style={{ color: "var(--accent)" }}>
                    Read case study <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
